import { useState, useEffect } from 'react';
import { ArrowUpRight, Building, AlertTriangle } from 'lucide-react';
import { PageShell, FG, INP, SEL, Row2, BtnPrimary, fmtINR, Spinner, useBanner, useWalletUser } from './WalletShared';
import walletController from '../../controllers/walletController';

const Withdraw = () => {
  const { userId } = useWalletUser();
  const { banner, notify, clearBanner } = useBanner();
  const [balance,  setBalance]  = useState(0);
  const [accounts, setAccounts] = useState([]);
  const [form,     setForm]     = useState({ amount:'', accountId:'', method:'bank_transfer', notes:'' });
  const [saving,   setSaving]   = useState(false);

  useEffect(() => {
    const load = async () => {
      const [balRes, accRes] = await Promise.all([
        walletController.getBalance(userId),
        walletController.getBankAccounts(userId),
      ]);
      if (balRes.success) setBalance(balRes.data?.available||0);
      if (accRes.success) setAccounts(accRes.data);
    };
    load();
  }, [userId]);

  const f = (k,v) => setForm(p => ({ ...p, [k]:v }));

  const handleWithdraw = async () => {
    if (!form.amount || Number(form.amount) <= 0) return notify('error','Enter a valid amount');
    if (Number(form.amount) > balance)            return notify('error','Insufficient balance');
    if (!form.accountId)                          return notify('error','Select a bank account');
    setSaving(true);
    const res = await walletController.withdraw(userId, { amount:Number(form.amount), accountId:form.accountId, method:'bank_transfer', notes:form.notes });
    setSaving(false);
    if (res.success) { notify('success', res.message); setForm({ amount:'', accountId:'', method:'bank_transfer', notes:'' }); }
    else notify('error', res.message);
  };

  return (
    <PageShell title="Withdraw" subtitle="Transfer funds to your bank account" icon={ArrowUpRight}
      banner={banner} onCloseBanner={clearBanner}>
      <div style={{ maxWidth:520, margin:'0 auto' }}>
        <div style={{ background:'linear-gradient(135deg,#1e293b,#334155)', borderRadius:12, padding:'18px 20px', marginBottom:20, color:'#fff' }}>
          <div style={{ fontSize:11, color:'#94a3b8', marginBottom:4 }}>Available Balance</div>
          <div style={{ fontSize:28, fontWeight:700 }}>{fmtINR(balance)}</div>
        </div>

        <div style={{ background:'#fff', borderRadius:14, border:'1px solid #f1f5f9', padding:'20px', display:'flex', flexDirection:'column', gap:16 }}>
          <FG label="Amount (₹) *">
            <INP type="number" min="1" max={balance} value={form.amount} onChange={e => f('amount',e.target.value)} placeholder="Enter withdrawal amount" style={{ fontSize:18, fontWeight:600, height:46 }}/>
            <button onClick={() => f('amount', String(balance))} style={{ alignSelf:'flex-start', background:'none', border:'none', color:'#3b82f6', fontSize:12, cursor:'pointer', padding:0 }}>
              Withdraw all ({fmtINR(balance)})
            </button>
          </FG>

          <FG label="Bank Account *">
            {accounts.length === 0
              ? <div style={{ display:'flex', alignItems:'center', gap:8, padding:'10px', background:'#fef9f0', border:'1px solid #fde68a', borderRadius:8, fontSize:13, color:'#92400e' }}>
                  <AlertTriangle size={14}/> No bank accounts added. <a href="/dashboard/wallet/bank-accounts" style={{ color:'#3b82f6' }}>Add one →</a>
                </div>
              : <SEL value={form.accountId} onChange={e => f('accountId',e.target.value)}>
                  <option value="">Select bank account</option>
                  {accounts.map(a => (
                    <option key={a._id} value={a._id}>{a.bankName} — ••••{String(a.accountNumber).slice(-4)}</option>
                  ))}
                </SEL>}
          </FG>

          <FG label="Notes (optional)">
            <INP value={form.notes} onChange={e => f('notes',e.target.value)} placeholder="Reason for withdrawal"/>
          </FG>

          {form.amount>0 && (
            <div style={{ background:'#f8fafc', borderRadius:8, padding:'12px 14px', fontSize:13 }}>
              <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}><span style={{ color:'#64748b' }}>You withdraw</span><span style={{ fontWeight:600 }}>{fmtINR(Number(form.amount))}</span></div>
              <div style={{ display:'flex', justifyContent:'space-between', fontSize:11, color:'#94a3b8' }}><span>Processing time</span><span>1–3 business days</span></div>
            </div>
          )}

          <BtnPrimary onClick={handleWithdraw} disabled={saving||!accounts.length} style={{ justifyContent:'center', padding:'11px' }}>
            {saving ? <><Spinner size={14}/>Processing…</> : <><ArrowUpRight size={14}/>Withdraw {form.amount?fmtINR(Number(form.amount)):''}</>}
          </BtnPrimary>
        </div>
      </div>
    </PageShell>
  );
};
export default Withdraw;